export default __webpack_public_path__ + "static/media/about-section-04.160a7257.png";